import React, { useState, useEffect } from "react";
import { styled } from '@mui/material/styles';
import {
    Container,
    Typography,
    List,
    ListItem,
    ListItemText,
    CircularProgress,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Card,
    CardContent,
    Grid,
    Button,
    CardActions,
    CardHeader,
    CardActionArea,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText
} from '@mui/material';
import { Link } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';


import { tableCellClasses } from '@mui/material/TableCell';
import Iconify from '../../../components/Iconify';

import UserService from '../../../services/user_service'
import PaymentService from '../../../services/payment_service'

const useStyles = styled((theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    title: {
        marginBottom: theme.spacing(3)
    },
    progress: {
        margin: theme.spacing(3)
    },
    table: {
        minWidth: 650,
    },
    tableHead: {
        backgroundColor: '#f5f5f5',
    },
    tableCell: {
        fontWeight: 'bold',
        color: '#333',
        border: '1px solid #ccc'
    },
    tableRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#f9f9f9',
        },
    },
}));


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default function UserSubscriptionPage() {

    const [openCancelQuation, setOpenCancelQuestion] = useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const classes = useStyles();
    const [subscription, setSubscription] = useState({
        status: "",
        history: [],
        subscription_plan: "",
        price: "",
        subscription_plan_id: -1,
        days_left: -1
    });
    const [isLoading, setIsLoading] = useState(true);

    function fetchSubscriptionData() {
        UserService.loadUserSubscription()
            .then((response) => response.data)
            .then((data) => setSubscription({
                status: data.status,
                subscription_plan: data.subscription_plan,
                price: data.price,
                subscription_plan_id: data.subscription_plan_id,
                days_left: data.days_left
            }))
            .then((data) => setIsLoading(false))

            .catch((error) => console.log(error))
    }
    useEffect(() => {

        fetchSubscriptionData();
    }, []);

    function handlePay() {
        PaymentService.getPaymentLink(subscription.subscription_plan_id, -1, 'inadvance')
            .then((response) => response.data)
            .then((data) => window.location.replace(data['url']))
            .catch((error) => console.log(error))
    }

    function handleCancel() {
        PaymentService.cancel()
            .then((response) => response.data)
            .then((data) => console.log(data))
            .then(fetchSubscriptionData())
    }

    function handleClose() {
        setOpenCancelQuestion(false);
    }

    function handleOpenQuestion() {
        setOpenCancelQuestion(true);
    }

    function handleYes() {
        setOpenCancelQuestion(false);
        handleCancel();
    }

    function renderSwitch(subscription) {
        var content = <CircularProgress className={classes.progress} />
        console.log('rendreing');
        if (subscription) {
            if (subscription.status === 'Trial' || subscription.status === 'Start') {
                content = <Grid item xs={12} sm={12} md={9}><Card className={classes.root}>
                    <CardContent>
                        <Grid container spacing={4}>
                            <Grid item xs={3} md={3} sm={3}>
                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                    Subscription status
                                </Typography>
                                <Typography variant="h5" component="h2">
                                    {subscription.status}
                                </Typography>

                            </Grid>
                            <Grid item xs={9} md={9} sm={9}>
                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                    Days left
                                </Typography>
                                <Typography variant="h5" component="h2">
                                    {subscription.days_left}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <CardActionArea >
                                    <Link to="/payment">
                                        <Button variant="outlined">Select subscription plan</Button>
                                    </Link>
                                </CardActionArea>
                            </Grid>
                        </Grid>

                    </CardContent>
                </Card>
                </Grid>
            } else if (subscription.status === 'Active') {
                content = <>
                    <Grid item xs={9} sm={9} md={9}>
                        <Card className={classes.root}>
                            <CardContent>
                                <Grid container spacing={4}>
                                    <Grid item xs={9} md={9} sm={9}>
                                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                                            Subscription plan
                                        </Typography>
                                        <Typography variant="h5" component="h2">
                                            {subscription.subscription_plan}
                                        </Typography>

                                    </Grid>
                                    <Grid item>
                                        <Box display="flex"
                                            justifyContent="flex-end"
                                            alignItems="flex-end">

                                            <Link to="/payment">
                                                <Button variant="outlined">Upgrade</Button>
                                            </Link>
                                        </Box>
                                    </Grid>

                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}>
                        <Card className={classes.root}>
                            <CardContent>
                                <Grid container spacing={4}>
                                    <Grid item xs={3} md={3} sm={3}>
                                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                                            Subscription status
                                        </Typography>
                                        <Typography variant="h5" component="h2">
                                            {subscription.status}
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={3} md={3} sm={3}>
                                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                                            Amount
                                        </Typography>
                                        <Typography variant="h5" component="h2">
                                            ${subscription.price}/month
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3} md={3} sm={3}>
                                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                                            Days left
                                        </Typography>
                                        <Typography variant="h5" component="h2">
                                            {subscription.days_left}
                                        </Typography>
                                    </Grid>

                                    <Grid item>
                                        <Box display="flex"
                                            justifyContent="flex-end"
                                            alignItems="flex-end">

                                            <Button onClick={handleOpenQuestion} variant="outlined">Cancel</Button>
                                            <Dialog
                                                fullScreen={fullScreen}
                                                open={openCancelQuation}
                                                onClose={handleClose}
                                                aria-labelledby="responsive-dialog-title"
                                            >
                                                <DialogTitle id="responsive-dialog-title">
                                                    {"Are you sure you want to cancel subscription?"}
                                                </DialogTitle>
                                                <DialogContent>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button autoFocus onClick={handleClose}>
                                                        No
                                                    </Button>
                                                    <Button onClick={handleYes} autoFocus>
                                                        Yes
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>
                                        </Box>
                                    </Grid>
                                    <Grid item>
                                        <Button onClick={handlePay} variant="outlined">Pay in advance</Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </>
            } else if (subscription.status === 'Canceled') {
                content = <Grid item xs={12} sm={12} md={9}><Card className={classes.root}>
                    <CardContent>
                        <Grid container spacing={4}>
                            <Grid item xs={3} md={3} sm={3}>
                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                    Subscription status
                                </Typography>
                                <Typography variant="h5" component="h2">
                                    {subscription.status}
                                </Typography>

                            </Grid>
                            <Grid item>
                                <CardActionArea >
                                    <Link to="/payment">
                                        <Button variant="outlined">Select subscription plan</Button>
                                    </Link>
                                </CardActionArea>
                            </Grid>
                        </Grid>

                    </CardContent>
                </Card>
                </Grid>
            }
        }
        return content;
    }


    return (


        <div>
            {isLoading ? (
                <CircularProgress className={classes.progress} />
            ) : (
                <Grid container spacing={3}>{ renderSwitch(subscription) }</Grid>
            )}
        </div>
    );
};